import type { TMessages } from '@/types/TMessages'

export const messages = {
  ELEVATOR: 'Цена на элеваторе',
  STORE: 'Цена на складе',
  EXW: 'Цена переписи на элеваторе',
  FOB: 'Цена на борту судна',
} satisfies TMessages
